// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__u4_DW","inputWrap":"CustomTip_inputWrap__2YaLK"};